import 'slick-carousel'

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    jQuery('#carousel').slick({
      autoplay: true,
      dots: false,
      prevArrow: false,
      nextArrow: false,
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js